import type { LaborDay2026SaleVariant } from '~/features/promotions/constants/labor-day-2026-sale';

import type { PromoCampaignSurfaceRenderers, RegisteredPromoCampaign } from '../types';

import { laborDay2026CampaignCore } from './campaign-core';
import { laborDay2026CampaignSurfaces } from './surfaces';

export { LABOR_DAY_2026_CAMPAIGN_ID, laborDay2026CampaignCore } from './campaign-core';

const laborDay2026PromoCampaignTyped = {
  ...laborDay2026CampaignCore,
  surfaces: laborDay2026CampaignSurfaces,
} satisfies PromoCampaignSurfaceRenderers<LaborDay2026SaleVariant>;

export const laborDay2026PromoCampaign = laborDay2026PromoCampaignTyped as RegisteredPromoCampaign;
